export const formatArticleDate = (value) => {
  if (!value) {
    return "";
  }
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return "";
  }
  return date
    .toLocaleDateString("it-IT", { day: "numeric", month: "short", year: "2-digit" })
    .replace(".", "")
    .toUpperCase();
};

export const formatReadingTime = (minutes) => {
  const safeMinutes = Number(minutes);
  if (!safeMinutes || safeMinutes < 1) {
    return "";
  }
  return `${safeMinutes} MIN DI LETTURA`;
};
